import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=618a0e9f&scoped=true&"
import script from "./photo.js?vue&type=script&lang=js&"
export * from "./photo.js?vue&type=script&lang=js&"
import style0 from "./photo.scss?vue&type=style&index=0&id=618a0e9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618a0e9f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VOverlay})
